import { Divider, Image } from "@heroui/react";
import { CareproviderFile } from "core/types";
import { useTranslations } from "translations";

type AdmissionsHeaderProps = {
  logo?: CareproviderFile;
};

export function AdmissionsHeader({ logo }: AdmissionsHeaderProps) {
  const translations = useTranslations();

  if (!logo) {
    return null;
  }

  return (
    <header className="min-w-full bg-white">
      <div className="mx-auto max-w-5xl px-3 py-5">
        <Image
          alt={
            translations.careproviderApp.recareAdmissionsForm
              .altTextLogoProvider
          }
          className="max-h-12"
          src={logo.url}
        />
      </div>
      <Divider aria-hidden="true" className="border-gray-300" />
    </header>
  );
}
